import ConfirmationModal from './ConfirmationModal.vue';

export default ConfirmationModal;
